import { NgModule } from '@angular/core';
import { AuthService } from './auth-service.component';
import { UserService } from '../commonservices/user.service';
import { AuthRouteGuard } from './auth-route-guard';
import { UpdateService } from './update-service.component';
import { environment } from '../../environments/environment';
import { LocalStorageService } from '../core/localstorage-service';
import { NotificationModule } from '@progress/kendo-angular-notification';

@NgModule({
    imports: [NotificationModule],
    exports: [
        ],
    declarations: [],
    providers: [
        AuthService,
        environment.production?UpdateService:[],
        UserService,
        AuthRouteGuard,
        LocalStorageService
    ],
})
export class CoreModule { }
